/* eslint-disable prettier/prettier */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export enum OrigemRequisicao {
  FiltroCarteiraLeads = 0,
  FiltroCriacaoOfertaAtiva = 1,
  Indicadores = 2,
}

interface Props {
  idSubEtapa?: string;
  idsEtapas?: string[];
  idRegional?: string;
  OrigemRequisicao?: OrigemRequisicao | null;
  queryKeySuffix?: string;
}

export function useGetSubetapas(props: Props) {
  const fetchData = async () => {
    const mapEtapas = props.idsEtapas
      ?.map((idEtapa) => `idsEtapas=${idEtapa}`)
      .join("&");
    const LISTAR_SUBETAPAS = `${leadsWebEnviroment}/common/funil/subetapas/v1?${
      props.idSubEtapa ? `idSubEtapa=${props.idSubEtapa}&` : ""
    }${mapEtapas}&idRegional=${props.idRegional ? props.idRegional : ""}${
      props.OrigemRequisicao
        ? `&OrigemRequisicao=${props.OrigemRequisicao}`
        : ""
    }`;
    const response = await instance.get(LISTAR_SUBETAPAS);
    return response?.data?.data;
  };

  const idsEtapasKey = props.idsEtapas?.sort().join(",") || "";
  const queryKey = [
    "listar_subetapas",
    props.idSubEtapa,
    idsEtapasKey,
    props.idRegional,
    props.OrigemRequisicao,
    props.queryKeySuffix,
  ].filter(Boolean);

  const query = useQuery({
    enabled: false,
    queryFn: fetchData,
    queryKey,
    refetchOnWindowFocus: false,
  });

  return query;
}
